var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0731 3.91897C23 5.3062 23 7.23734 23 11.0996C23 14.9619 23 16.893 22.0731 18.2802C21.6718 18.8808 21.1562 19.3964 20.5556 19.7977C19.3438 20.6074 17.7168 20.7098 14.75 20.7227V20.7246L13.2298 23.7649C12.7231 24.7784 11.2769 24.7784 10.7702 23.7649L9.25 20.7246V20.7227C6.28316 20.7098 4.65622 20.6074 3.44436 19.7977C2.84382 19.3964 2.32819 18.8808 1.92692 18.2802C1 16.893 1 14.9619 1 11.0996C1 7.23734 1 5.3062 1.92692 3.91897C2.32819 3.31843 2.84382 2.8028 3.44436 2.40153C4.83159 1.47461 6.76273 1.47461 10.625 1.47461H13.375C17.2373 1.47461 19.1684 1.47461 20.5556 2.40153C21.1562 2.8028 21.6718 3.31843 22.0731 3.91897Z",
    stroke: "#0D45DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 8.34961L16.125 8.34961",
    stroke: "#0D45DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 13.8496H12",
    stroke: "#0D45DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatActive);
export default __webpack_public_path__ + "static/media/chat_active.76031721df5bd8cef5b9a0ff2d59318f.svg";
export { ForwardRef as ReactComponent };